class SlideshowMB {
  constructor(element) {
    this.element = element;
    this.slider = element.querySelector('.slideshow-mb__slider');

    if (!this.slider) return;

    this.init();
  }

  init() {
    if (this.slider.swiper) {
      this.slider.swiper.destroy(true, true);
    }

    const slideCount =
      this.slider.querySelectorAll('.swiper-slide').length;

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,

      effect: 'fade',

      fadeEffect: {
        crossFade: true,
      },

      speed: 1000,

      loop: slideCount > 1,

      allowTouchMove: slideCount > 1,

      autoplay:
        slideCount > 1
          ? {
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }
          : false,

      pagination:
        slideCount > 1
          ? {
              el: this.slider.querySelector(
                '.slideshow-mb__pagination'
              ),
              clickable: true,
            }
          : false,

      on: {
        beforeTransitionStart(swiper) {
          swiper.slides.forEach((slide) => {
            slide.classList.remove('is-leaving');
          });

          const previousSlide =
            swiper.slides[swiper.previousIndex];

          if (previousSlide) {
            previousSlide.classList.add('is-leaving');
          }
        },

        transitionEnd(swiper) {
          swiper.slides.forEach((slide) => {
            slide.classList.remove('is-leaving');
          });
        },
      },
    });
  }
}


function initSlideshowMB(container = document) {
  const sliders =
    container.querySelectorAll('[data-slideshow-mb]');

  sliders.forEach((slider) => {
    if (slider.dataset.initialized === 'true') return;

    slider.dataset.initialized = 'true';

    new SlideshowMB(slider);
  });
}


document.addEventListener('DOMContentLoaded', () => {
  initSlideshowMB();
});


document.addEventListener('shopify:section:load', (event) => {
  initSlideshowMB(event.target);
});